export const TIMELOG = "timelog";
export const MYSCHEDULE = "my-schedule";
export const CALENDAR = "calendar";
export const MY_HOLIDAYS = "my-holidays";
export const DASHBOARD = "dashboard";
export const REPORTS = "reports";
export const TIMESHEET = "timesheet";
